<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.pa"
                    label="PA"
                    v-mask="getMaskPa"
                    v-model="model.pa"
                    placeholder="000/000"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.MILIMETROS_DE_MERCURIO).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.glicemia"
                    label="Glicemia"
                    v-mask="getMaskGlicemia"
                    v-model="model.glicemia"
                    placeholder="000"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.MILIGRAMAS_POR_DECILITRO).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.temperatura"
                    label="Temperatura"
                    v-mask="getMaskTemperatura"
                    v-model="model.temperatura"
                    placeholder="00,0"
                >
                    <template slot="append">
                        <rkm-button
                            color="secondary"
                        >
                            {{ getUnidadeMedida(enums.UnidadeMedida.CELSIUS).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.pulso"
                    label="Pulso"
                    v-mask="getMaskPulso"
                    v-model="model.pulso"
                    placeholder="000"
                >
                    <template slot="append">
                        <rkm-button
                            color="secondary"
                        >
                            {{ getUnidadeMedida(enums.UnidadeMedida.BATIMENTOS_POR_MINUTO).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.respiracao"
                    label="Respiração"
                    v-mask="getMaskRespiracao"
                    v-model="model.respiracao"
                    placeholder="000"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.MOVIMENTOS_POR_MINUTO).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.saturacao"
                    label="Saturação"
                    v-mask="getMaskSaturacao"
                    v-model="model.saturacao"
                    placeholder="000"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.PORCENTAGEM).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.intensidadeDor"
                    label="Intensidade da dor"
                    v-mask="getMaskIntensidadeDor"
                    v-model="model.intensidadeDor"
                    placeholder="0"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.NIVEL_DE_DOR).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.cintura"
                    label="Cintura"
                    v-mask="getMaskCintura"
                    v-model="model.cintura"
                    placeholder="000"
                >
                    <template slot="append">
                        <rkm-button color="secondary">
                            {{ getUnidadeMedida(enums.UnidadeMedida.CENTIMETROS).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { mask, unmask, repository } from '@/mixins'

// Enums.
import UnidadeMedida from '@/enums/cadastro/unidadeMedida'

export default {
    computed: {
        campoRequired() {
            return (
                !this.model.pa &&
                !this.model.glicemia &&
                !this.model.temperatura &&
                !this.model.pulso &&
                !this.model.respiracao &&
                !this.model.saturacao &&
                !this.model.intensidadeDor &&
                !this.model.cintura
            )
        },
        validations() {
            return {
                pa: {
                    required: this.campoRequired,
                    min_max_without_mask: [6],
                    pressao_arterial: true,
                },
                glicemia: {
                    required: this.campoRequired
                },
                temperatura: {
                    required: this.campoRequired,
                    min: 4,
                    max: 4,
                },
                pulso: {
                    required: this.campoRequired
                },
                respiracao: {
                    required: this.campoRequired
                },
                saturacao: {
                    required: this.campoRequired,
                    max_value: 100,
                    min_value: 1
                },
                intensidadeDor: {
                    required: this.campoRequired,
                    max_value: 10,
                    min_value: 1
                },
                cintura: {
                    required: this.campoRequired
                },
            }
        },
        getMaskPa(){
            return '###/###'
        },
        getMaskGlicemia(){
            return '###'
        },
        getMaskTemperatura(){
            return '##,#'
        },
        getMaskPulso(){
            return '###'
        },
        getMaskRespiracao(){
            return '##'
        },
        getMaskSaturacao(){
            return '###'
        },
        getMaskIntensidadeDor(){
            return '##'
        },
        getMaskCintura(){
            return '###'
        },
    },
    data: () => ({
        enums: { UnidadeMedida },
    }),
    methods: {
        getUnidadeMedida(id) {
            return this.data.form.unidadesMedida.find(unidade => unidade.id === id)
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.model.id) {
                        const index = this.data.model.sinaisVitais.findIndex(item => item.id === this.model.id)
                        Object.assign(this.data.model.sinaisVitais[index], this.model)
                    } else {
                        this.model.id = this.uniqueId('pronto-atendimento-sinal-vital')
                        this.data.model.sinaisVitais.push(this.model)
                    }

                    this.$emit('saved', this.model)

                }
            })
        },
    },
    mixins: [ mask, unmask, repository ],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>